module.exports = __webpack_public_path__ + "img/VPS-manufacturing-firms.a2f9b3e.jpg";